import { courseConfigs } from '@modules/learning/constants/courseConfigs';
import { useTranslation } from '@rbx/intl';
import { CourseIdEnum } from '@modules/learning/types/learning';
import { coursesPathSuffix } from '@modules/learning/constants/coursesNavConstants';

export type BreadcrumbItem = { label: string; path?: string | null };

export function useLessonBreadcrumbs(slugs: string[]): BreadcrumbItem[] {
  const { translate } = useTranslation();

  if (slugs.length < 4) {
    return [];
  }

  const [courses, courseName, milestoneName, lessonName] = slugs;

  const breadcrumbs: BreadcrumbItem[] = [];

  breadcrumbs.push({
    label: translate('Label.Courses'),
    path: coursesPathSuffix,
  });

  const courseConfig = courseConfigs.find((config) => config.id === (courseName as CourseIdEnum));
  const milestoneNum = parseInt(milestoneName.split('-')[1], 10);
  if (courseConfig) {
    breadcrumbs.push({
      label: `${translate(courseConfig.titleKey)}: ${translate('Label.Milestone')} ${milestoneNum}`,
      path: `${coursesPathSuffix}/${courseName}/${milestoneName}/${lessonName}`,
    });
  }

  return breadcrumbs;
}
